import { useEffect, useState } from 'react';
import { Card, ConfigProvider, Divider, Flex, Layout, Typography } from 'antd';
import { Outlet, useNavigate, useLocation } from 'react-router-dom';
import './HistoryAndReports.css';

const { Content } = Layout;
const { Title } = Typography;

const activityList = [
  {
    label: 'Trips Report',
    path: 'trips-report',
    key: 'trips-report',
    disabled: false,
  },
  {
    label: 'SOS Report',
    path: 'sos-report',
    key: 'sos-report',
    disabled: false,
  },
  {
    label: 'Anomaly Report',
    path: 'anomaly-report',
    key: 'anomaly-report',
    disabled: false,
  },
  {
    label: 'Driver Drowsiness Report',
    path: 'driver-drowsiness-report',
    key: 'driver-drowsiness-report',
    disabled: false,
  },
  {
    label: 'Camera Error Report',
    path: 'camera-error-report',
    key: 'camera-error-report',
    disabled: false,
  },
];

const HistoryAndReports = () => {
  const navigate = useNavigate();
  const location = useLocation();

  const currentPath = location.pathname.split('/').pop();
  const defaultReport =
    activityList.find(activity => activity.key === currentPath)?.key ||
    'trips-report';

  const [selectedReport, setSelectedReport] = useState(defaultReport);

  useEffect(() => {
    setSelectedReport(defaultReport);
  }, [defaultReport]);

  const handleReportSelection = activity => {
    setSelectedReport(activity.key);
    navigate(activity.path);
  };

  return (
    <ConfigProvider
      theme={{
        components: {
          Typography: {
            titleMarginBottom: 0,
            titleMarginTop: 0,
          },
          Layout: {
            siderBg: 'var(--secondary-fill-color, #2E3033)',
            headerBg: 'transparent',
            headerPadding: '0',
          },
        },
        token: {
          fontSize: '0.875rem',
        },
      }}
    >
      <Layout className="layout-page">
        <Content className="full-height">
          <Card
            variant="borderless"
            type="small"
            className="card-history-and-report"
          >
            <Flex className="full-height" gap={16}>
              <Flex className="full-height" vertical gap={24}>
                <Title level={4} className="title-page">
                  Activity
                </Title>
                <Flex vertical style={{ minWidth: '300px' }}>
                  {activityList?.map(activity => (
                    <Card
                      key={activity?.key}
                      className={`activity-item ${activity.disabled ? 'disabled' : ''}`}
                      variant="borderless"
                      onClick={() =>
                        !activity.disabled && handleReportSelection(activity)
                      }
                      style={{
                        backgroundColor:
                          activity.key === selectedReport
                            ? 'var(--selected-bg-color, #D0D4D8)'
                            : 'var(--secondary-fill-color, #2E3033)',
                        color:
                          activity.key === selectedReport &&
                          'var(--selected-text-color, #000000)',
                      }}
                    >
                      {activity?.label}
                    </Card>
                  ))}
                </Flex>
              </Flex>

              <Divider type="vertical" className="full-height" />

              <div
                className="full-height"
                style={{ flexGrow: 1, overflow: 'auto' }}
              >
                <Outlet />
              </div>
            </Flex>
          </Card>
        </Content>
      </Layout>
    </ConfigProvider>
  );
};

export default HistoryAndReports;
